import { reactive, watch } from 'vue'

const STORAGE_KEY = 'kooyii-cart'

const loadList = () => {
    try {
        const raw = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]')
        return Array.isArray(raw) ? raw : []
    } catch {
        return []
    }
}

export const cartState = reactive({
    list: loadList(),
    open: false,
    step: 1,
})

watch(cartState, () => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(cartState.list))
}, { deep: true })

export function addToCart(product) {
    const id = Number(product?.id)
    if (!id) return
    const existing = cartState.list.find((item) => Number(item.id) === id)
    if (existing) {
        existing.quantity += 1
    } else {
        cartState.list.push({
            ...product,
            id,
            quantity: 1,
            rate: Number(product.rate) || 6.8,
        })
    }
    cartState.step = 1
}

export function flyToCart(fromEl, image) {
    const cart = document.querySelector('.floating-cart')
    if (!fromEl || !cart) return
    const from = fromEl.getBoundingClientRect()
    const to = cart.getBoundingClientRect()
    const token = document.createElement('span')
    token.className = 'cart-fly-token'
    if (image) {
        const img = document.createElement('img')
        img.src = image
        img.alt = ''
        token.appendChild(img)
    } else {
        token.classList.add('is-plain')
    }
    const plus = document.createElement('span')
    plus.className = 'cart-fly-plus'
    plus.textContent = '+1'
    token.appendChild(plus)

    const x = from.left + from.width / 2
    const y = from.top + from.height / 2
    const endX = to.left + to.width / 2
    const endY = to.top + to.height / 2
    const dx = endX - x
    const dy = endY - y
    const sway = dx > 0 ? -88 : 88
    const lift = Math.min(-120, dy * 0.25)
    token.style.left = `${x}px`
    token.style.top = `${y}px`
    document.body.appendChild(token)

    const animation = token.animate([
        { offset: 0, transform: 'translate(-50%, -50%) scale(0.18) rotate(-8deg)', opacity: 0 },
        { offset: 0.08, transform: 'translate(-50%, -50%) scale(0.28) rotate(-4deg)', opacity: 1 },
        { offset: 0.28, transform: 'translate(-50%, -50%) scale(1) rotate(0deg)', opacity: 1 },
        {
            offset: 0.55,
            transform: `translate(calc(-50% + ${dx * 0.46 + sway}px), calc(-50% + ${dy * 0.22 + lift}px)) scale(1.04) rotate(8deg)`,
            opacity: 1,
        },
        {
            offset: 1,
            transform: `translate(calc(-50% + ${dx}px), calc(-50% + ${dy}px)) scale(0.18) rotate(16deg)`,
            opacity: 0.85,
        },
    ], {
        duration: 780,
        easing: 'cubic-bezier(0.45, 0.02, 0.2, 1)',
        fill: 'forwards',
    })

    animation.onfinish = () => {
        token.remove()
        cart.classList.remove('is-bump')
        void cart.offsetWidth
        cart.classList.add('is-bump')
        setTimeout(() => cart.classList.remove('is-bump'), 460)
    }
}
